import { gql } from '@grandvisionhq/graphql';

const contactLensesTypeDetails = gql`
  fragment ContactLensesTypeDetailsFragment on ContactLensesTypeDetails {
    eyeSide
    isSubscription
    subscriptionDetails {
      deliveryInterval
    }
    prescriptionData {
      addition
      axis
      baseCurve
      cylinder
      diameter
      dominance
      power
      __typename
    }
    colors {
      locale
      values
    }
    __typename
  }
`;

export { contactLensesTypeDetails };
//# sourceMappingURL=contact-lenses.js.map
